module.exports = __webpack_public_path__ + "pdf/year-in-brief.13e9688.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/year-in-brief.pdf
// module id = 8n3m
// module chunks = 0